// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acc_drpdwn___single-value {
  white-space: pre-wrap !important;
}

.acc_drpdwn___indicator svg {
  color: #00aeef;
}

#linkTxt {
  text-align: -webkit-center !important;
  text-align: -moz-center;
}`, "",{"version":3,"sources":["webpack://./node_modules/@alinta-digital/asg/components/DropdownIcons/index.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB","sourcesContent":[".acc_drpdwn___single-value {\r\n  white-space: pre-wrap !important;\r\n}\r\n\r\n.acc_drpdwn___indicator svg {\r\n  color: #00aeef;\r\n}\r\n\r\n#linkTxt {\r\n  text-align: -webkit-center !important;\r\n  text-align: -moz-center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
